export function restructureGetAllSOPs(getAllSOPs) {
  if (!getAllSOPs) return [];
  return getAllSOPs.map((sop) => {
    const { taskTemplates, ...rest } = sop;
    return {
      ...rest,
      taskTemplateList: taskTemplates
        ? taskTemplates?.map(({ taskOrder, taskTemplate }) => ({
            taskOrder,
            ...taskTemplate
          }))
        : []
    };
  });
}
